import { render, staticRenderFns } from "./CurrentBalance.vue?vue&type=template&id=df3f1586&"
import script from "./CurrentBalance.vue?vue&type=script&lang=js&"
export * from "./CurrentBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports